import React, { useState, useMemo } from 'react'
import { ProductImage } from 'components'
import productStyleController from '@ctrls/productStyleController'
import { ddayjs, classNames } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  data: any;
}

const WaterfallActivityItem: React.FC<IProps> = props => {
  const { data } = props
  const isNoImg = useMemo(() => {
    return !(data.playbill && data?.extra?.playbillSize?.width)
  }, [data])
  const isDisable = useMemo(() => {
    return !!data.isDisable
  }, [data])
  const [productStyle] = useState(() => {
    const { width: picWidth, height: picHeight } = data?.extra?.playbillSize || {}
    const imgWidth = window.innerWidth / 2 - productStyleController.getWidthPer(3)
    const imgHeight = imgWidth * Number(picHeight || 360) / Number(picWidth || 360)
    return {
      width: imgWidth,
      height: imgHeight
    }
  })

  const getEatType = useMemo(() => {
    let eatTypesArr = []
    const { channels = [] } = data?.channelEatType || {}

    channels.forEach(channel => {
      const { eatTypes } = channel
      eatTypes.forEach(eatType => {
        if (!eatTypesArr.includes(eatType)) {
          eatTypesArr.push(eatType)
        }
      })
    })

    return eatTypesArr
  }, [])
  return (
    <div className={classNames('waterfall-activity-item', { 'activity-disable-item': isDisable, 'no-img': isNoImg })}>
      {
        !isNoImg && (
          <ProductImage
            color=''
            imgSrc={data.playbill}
            width={productStyle.width}
            height={productStyle.height}
            className='waterfall-img'
          />
        )
      }
      <div className='waterfall-activity-info'>
        <div className='title'>{data.activityName}</div>
        <div className='tags'>
          {
            data.channelEatType.isAll ? i18n.t('activity.allEatType') : (
              getEatType.map((eatType, index) => {
                return <span key={eatType}>{i18n.t(`menu.${eatType}`)}{index !== getEatType.length - 1 && '\\'}</span>
              })
            )
          }
        </div>
        <div>{i18n.t('activity.partInPeople')}:
          {
            data.isAllMember ? i18n.t('activity.allMember') : (
              data.cardsName.map((name, index) => {
                return <span key={name}>{name}{index !== data.cardsName.length - 1 && ';'}</span>
              })
            )
          }
        </div>
        <div className='time'>{i18n.t('mkt.common.toDate')}:{ddayjs(data.endTime).format('YYYY-MM/DD')} </div>
        {
          !isDisable && <div className='btn'>{i18n.t('activity.join')}</div>
        }
      </div>
    </div>
  )
}

export default WaterfallActivityItem
